
/** cookies **/
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
   function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function eraseCookie(key) {
        var keyValue = getCookie(key);
        setCookie(key, keyValue, '-1');
    }
/** cookies end**/
jQuery(document).ready(function(){ 

/* NEW: detect if current template is new-custom-bundle-product */
var isNewBundleTemplate = jQuery('[data-template-suffix="new-custom-bundle-product"]').length > 0;

jQuery(document).on('click', '.product-card__swatches.custom-selector .swatches .swatch-value', function() {
  
  let v_id = jQuery(this).data("v-id");
  let style = jQuery(this).find("a.swatch-color").attr("style");
  let option_value=jQuery(this).find(".option-badge-wrapper").html()
 console.log("option_value===",option_value)
  let targetColor = jQuery(this).closest(".product-card").find(".selected.swatch-value a.swatch-color");
  let targetValue = jQuery(this).closest(".product-card").find(".selected.swatch-value .option-badge-wrapper");
  targetColor.attr("style", style);
    console.log("targetValue====",targetValue)
  targetValue.html(option_value);
  if (jQuery(this).find(".option-badge-wrapper").hasClass("has-badge")) {
    targetValue.addClass("has-badge");
  }
  else{
targetValue.removeClass("has-badge")
  }

  // console.log("Style==2==", targetColor.attr("style"));
  console.log("v_id==", v_id);

  jQuery(this).closest(".product-card").find("select.product-variant-select").val(v_id).trigger('change');
    jQuery('.product-card__swatches.custom-selector .swatches').removeClass("active")
    // alert('here')
     jQuery('.product-card__swatches.custom-selector').removeClass("active")
});

 jQuery(document).on('click', '.product-card__swatches.custom-selector .swatch-color-selected', function() {
  // Remove 'active' class from all swatches
  jQuery('.product-card__swatches.custom-selector .swatches').not(jQuery(this).siblings("ul.swatches")).removeClass('active');
 jQuery('.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")).removeClass('active');
//  console.log("test===", jQuery('.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")));
 
  // Toggle 'active' only on the clicked element's sibling swatches
  jQuery(this).siblings("ul.swatches").toggleClass("active");
  jQuery(this).parents(".custom-selector").toggleClass("active");

  console.log("show selector=5=", jQuery(this).siblings("ul"));
});

/* NEW: on new-custom-bundle-product, clicking CREATE YOUR BUNDLE auto-selects every product on the collection into the drawer */
jQuery(document).on('click', '.bundle-drawer-btn .show-bundle-btn', function(e){
  if(isNewBundleTemplate){
    jQuery('.custom-radios').not('.main-clicked').each(function(){
      jQuery(this).trigger('click');
    });
  }
});


var x=0;
    var no_of_items = jQuery('.custom-radios').attr('numb-of-items');
	jQuery(document).on('click', '.custom-radios', function(e)	 { 
 e.preventDefault();
        console.log("Custom radio click====");
        
      
    var data_id = jQuery(this).attr('data-attr');
    var data_v_title = jQuery(this).attr('data-variant-title');
    var data_v_price = jQuery(this).attr('data-price');
    var data_v_img = jQuery(this).attr('data_img');
    var data_p_title = jQuery(this).attr('data_product_title');
    var data_p_id = jQuery(this).attr('data-pid');
    var drawer_prdct = jQuery(this).parents(".f-column.card.bundle_template").find(".main-container-div-jtpl").html();
    // console.log("drawer_prdct===");
    
    jQuery(this).toggleClass("main-clicked");
    jQuery(this).parents(".f-column").find(".product-card__wrapper").toggleClass("active");
    var check_length =  jQuery(".custom-radios.main-clicked").length;
  console.log("Items in cart==",jQuery('.cstm-append-cls .all-info-container').length );
  
      if (jQuery(this).hasClass("main-clicked")){
      jQuery(".cstm-append-cls").append(drawer_prdct);
      console.log("product-appended===");
      
      if(jQuery('.cstm-append-cls .all-info-container').length < 1){
        console.log("Hide drawer button====");
        
      jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
      }else{
       jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
       console.log("Show drawer button====");
     }
      if(isNewBundleTemplate){
      jQuery('.bundle-drawer-btn').show();
      }else{
      if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
      jQuery('.bundle-drawer-btn').show();
      console.log("Show create bundle btn");
      
      }else{
      jQuery('.bundle-drawer-btn').hide();
       console.log("Hide create bundle btn");
      }
      }
      var productData=[];
      var getBundledata= getCookie('bundle-selected-product');
     if (getBundledata.length > 0){
      getBundledata = getBundledata.split(',');
      jQuery(getBundledata).each(function(index,value){
      productData.push(value);
     });
   }if(productData.length >0){
      if(productData.indexOf(data_id) < 0 ){
      productData.push(data_id+'#'+data_v_title+'#'+data_v_price+'#'+data_p_title+'#'+data_v_img+'#'+data_p_id);
     }
   }
    else{
      productData.push(data_id+'#'+data_v_title+'#'+data_v_price+'#'+data_p_title+'#'+data_v_img+'#'+data_p_id);
   }
      setCookie('bundle-selected-product', productData, 1);
      jQuery(this).parents('.bundle_template').find(".checked").css({ "display": "block" , "background": "#000"});
      jQuery(this).parents('.bundle_template').find(".choose-to-add-bundle").css("display", "none"); 
    }
      else{
        jQuery('.all-info-container.cart-product[var-id="'+data_id+'"]').find('.remove-prdct').trigger('click');
        if(jQuery('.cstm-append-cls .all-info-container').length < 1){
        jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
      }else{
        jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
     }
          jQuery(this).parents('.bundle_template').find(".choose-to-add-bundle").css("display", "block"); 
          jQuery(this).parents('.bundle_template').find(".checked").css({ "display": "none" , "background": "#000"});
      }
	 return false;
    });

   

    jQuery(document).on('click', '.bundle-drawer-close-btn , .bundle-drawer-btn', function(){   
      // alert('modalhere 1')
     var drawer_prdct = jQuery(this).parents(".cc-product-block").find(".main-container-div-jtpl").html();
     if(jQuery(this).hasClass('bundle-drawer-btn') && !isNewBundleTemplate){
        jQuery(this).hide();
     
     }
      if(jQuery(this).hasClass('modal-close') && !isNewBundleTemplate){
      if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
        jQuery('.bundle-drawer-btn').show();

        }else{
        jQuery('.bundle-drawer-btn').hide();

        }
      }
        jQuery('.bundle-drawer-right').toggleClass('bundle-drawer-open');
        if(jQuery('.cstm-append-cls .all-info-container').length < 1){
        jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
     }else{
        jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
     }
      jQuery("body").toggleClass("collection-bndle-open");
  });
  
    jQuery(document).on('click', '.remove-prdct', function(){ 
    var v_id = jQuery(this).parents(".all-info-container").attr('var-id');
    var p_id = jQuery(this).parents(".all-info-container").attr('pd_id');        
    jQuery(this).parents(".cstm-append-cls .all-info-container").remove();
       
    jQuery('.custom-radios[data-attr="'+v_id+'"]').removeClass('main-clicked');
    jQuery('.custom-radios[data-attr="'+v_id+'"]').parents(".f-column").find(".product-card__wrapper").removeClass("active")
    jQuery('.custom-radios[data-attr="'+v_id+'"]').find('.choose-to-add-bundle').css("display", "block");
    jQuery('.custom-radios[data-attr="'+v_id+'"]').find('.checked').css({ "display": "none" , "background": "#000"});
            
    if(jQuery('.cstm-append-cls .all-info-container').length < 1){
    jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
    }
    if(!isNewBundleTemplate){
    if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
    jQuery('.bundle-bundle-btn.bundle_btn_active').show();
    }else{
    jQuery(".modal-close.bundle-drawer-close-btn").trigger('click');
    }
    }
   
    var new_bndl_val=[];
    var getBundledata= getCookie('bundle-selected-product');
    getBundledata = getBundledata.split(',');
    jQuery(getBundledata).each(function(index,value){
    var variant_data = value.split('#');
    if(variant_data[0] != v_id){
    new_bndl_val.push(value);
    }
  });
   setCookie('bundle-selected-product', new_bndl_val, 1);
 });

 jQuery(document).on('click', function(e){
  var $drawer = jQuery('.bundle-drawer-right');

  // drawer open hai aur click drawer ke bahar hua, aur trigger button pe bhi nahi hua
  if($drawer.hasClass('bundle-drawer-open') &&
     !jQuery(e.target).closest('.bundle-drawer-right').length &&
     !jQuery(e.target).closest('.bundle-drawer-btn').length){

    $drawer.removeClass('bundle-drawer-open');
    jQuery("body").removeClass("collection-bndle-open");

    // yehi logic jo close-btn click pe chalta hai, wahi yahan bhi chalana hoga
    if(!isNewBundleTemplate){
      if(jQuery('.cstm-append-cls .all-info-container').length >= no_of_items){
        jQuery('.bundle-drawer-btn').show();
      } else {
        jQuery('.bundle-drawer-btn').hide();
      }
    }
  }
});



 /* get bundle product cookies */
    var productData=[];
    var getBundledata= getCookie('bundle-selected-product');
     if(jQuery('.cstm-append-cls .all-info-container').length <1){
      jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
     }else{
       jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
     }
   if(getBundledata != undefined && getBundledata.length >0){
     getBundledata = getBundledata.split(',');
     jQuery(getBundledata).each(function(index,value){
   var variant_data = value.split('#');
        console.log("variant_data==",variant_data);
   var bundle_pd = jQuery(`<div class="all-info-container cart-product" var-id="${variant_data[0]}" pd_id=""><div class="product-media-jtpl cart-product__image"><img class="variantsel-img-bundle-jtpl" width='100' height='100' src="${variant_data[4]}"> </div><div class="product-details-info-jtpl cart-product__content"><p class="cart-product__content__title product-title">${variant_data[3]}</p><p class="cart-product__content__price"> <span class="prdct-price">${variant_data[2]}</span></p><span class="cart-product__content__meta prdct-variant">${variant_data[1]}</span></div><input class="variantsel-bundle-jtpl" name="id" value="${variant_data[0]}" type="hidden"><div class="cstm-remove-andqntty-jtpl">
                   <div class="cstm-quantity-wrapper-jtpl">
                   <a class="cstm-minus" id="ae-formFieldLabelOptIn_5k8gv4i1s47_14"><span>−</span></a>
                <input class="variantsel-bundle-jtpl-qntty"   min="1" name="quntity" value="1" type="number" aria-labelledby="ae-formFieldLabelOptIn_5k8gv4i1s47_14"/>
                   <a class="cstm-plus"><span>+</span></a>
                   </div>
                   <span class="remove-prdct">Remove</span>
                   </div>
           </div>`);
    jQuery('.inner.bundle-drawer.bundle-drawer-right span.cstm-append-cls').append(bundle_pd);
    jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('li.grid__item.bundle_template').find('.product-variant-select option[value="'+variant_data[0]+'"]').attr('selected','selected');
    
    jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').attr({'data-attr':variant_data[0],'data_img':variant_data[4],'data-price':variant_data[2],'data-variant-title':variant_data[1]});
    jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container').attr('var-id',variant_data[0]); 
    jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container img.variantsel-img-bundle-jtpl').attr('src',variant_data[4]); 
    jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container .product-details-info-jtpl .prdct-variant').html(variant_data[1]); 
    jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container .product-details-info-jtpl .variantsel-bundle-jtpl').attr('value',variant_data[0]);       
    jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').addClass('main-clicked');
    jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').parents(".f-column").find(".product-card__wrapper").addClass("active")
    jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').find(".checked").css({ "display": "block" , "background": "#000"});
    jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').find(".choose-to-add-bundle").css("display", "none"); 
      });
 
 

   }
   setTimeout(function(){
     jQuery('.product-variant-select').trigger("change");
    if(isNewBundleTemplate){
    jQuery('.bundle-drawer-btn').show();
    }else{
    if(jQuery('.inner.bundle-drawer.bundle-drawer-right .cstm-append-cls .all-info-container').length  >= no_of_items){
    jQuery('.bundle-drawer-btn').show();
    }else{
    jQuery('.bundle-drawer-btn').hide();
    }
    }
  });
  // jQuery('body').on('change', '.product-variant-select', function(e){
  jQuery('body').on('change', '.bundle_template .product-variant-select', function(e){
    e.preventDefault();
    var editid_bundle = jQuery(this).val();
    // Update Add To Cart form with selected variant
jQuery(this)
    .closest('.product-card')
    .find('form.add_to_cart_index input[name="id"]')
    .val(editid_bundle);

jQuery(this)
    .closest('.product-card')
    .find('form.add_to_cart_index .product-variant-id')
    .val(editid_bundle);
    var vr_img = jQuery(this).find('option:selected').attr('data-src-img');
    var data_src = jQuery(this).find('option:selected').attr('data-src');
    console.log("editid_bundle===",editid_bundle);
    // console.log("vr_img===",vr_img);
    // console.log("data_src===");
    
    var vr_price = jQuery(this).find('option:selected').attr('data-vprice');
    var vr_title = jQuery(this).find('option:selected').attr('variant-data');
    console.log("vr_price===",vr_price);
    // console.log("vr_title===",vr_title);
    jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data_img',vr_img);
    jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-price',vr_price);
    jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-variant-title',vr_title);
    jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .all-info-container').attr('var-id',editid_bundle);
    jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .variantsel-img-bundle-jtpl').attr('src',vr_img);
    jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .prdct-price').text(vr_price);
    jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .prdct-variant').text(vr_title);
    jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .variantsel-bundle-jtpl').val(editid_bundle);
    jQuery(this).parents('.f-column.card.bundle_template').find('.product-card__image img').attr('srcset',data_src);
     
    var variant_id = jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-attr',editid_bundle);
    var check_length = jQuery('.cstm-append-cls .all-info-container .variantsel-bundle-jtpl[value="'+editid_bundle+'"]').length;
    if (check_length > 0){
     jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').addClass('main-clicked');
      jQuery(this).parents('.f-column.card.bundle_template').find(".product-card__wrapper").addClass("active");
     jQuery(this).parents('.f-column.card.bundle_template').find(".checked").css({ "display": "block" , "background": "#000"});
     jQuery(this).parents('.f-column.card.bundle_template').find(".choose-to-add-bundle").css("display", "none"); 
    }else{
      jQuery(this).parents('.f-column.card.bundle_template').find(".product-card__wrapper").removeClass("active");
      jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').removeClass('main-clicked');
     jQuery(this).parents('.f-column.card.bundle_template').find(".checked").css({ "display": "none" , "background": "#000"});
     jQuery(this).parents('.f-column.card.bundle_template').find(".choose-to-add-bundle").css("display", "block"); 
    }
    return false;
  });
   /* Get bundle product cookies end*/
  
    jQuery(document).on('click', '.cstm-minus', function(){
    var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
    prdct_quntity--;
    jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").attr("value", prdct_quntity);
     
    if(prdct_quntity < 1){
    jQuery(this).parents(".all-info-container").find(".remove-prdct").trigger('click');
    }
    var qnty =0;
    jQuery('.inner.cart-drawer .all-info-container .cstm-remove-andqntty-jtpl .variantsel-bundle-jtpl-qntty').each(function () {
    qnty= qnty + parseInt(this.value);
    });
    if(qnty < 2){
    jQuery(".cart-drawer-close-btn").trigger('click');
    }
   });
    jQuery(document).on('click', '.cstm-plus', function(){
    var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
    var variant_id = jQuery(this).parents(".all-info-container").find('.variantsel-bundle-jtpl').attr('value');
    prdct_quntity++;
    jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").attr("value", prdct_quntity);
 });

     jQuery(document).on('click', '.custom-add-to-cart', function(){  
      console.log("add to cart click===");
      
         var items = new Array();
         var discount_code = jQuery(".cartform .cart_bundle_disc").val();
         jQuery('.cstm-append-cls .variantsel-bundle-jtpl').each(function() {
          var upsell= {};
          var pro_variant_id = jQuery(this).val();
          var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
          var properties = {};
          properties["_bundle"] = "bundle";
          if(jQuery("body").hasClass("page-pick-3-amp-save-50")){
          properties["_pick_bundle"] = "pick-3-save-50";
          }
          upsell['id'] = pro_variant_id;
          upsell['quantity'] = prdct_quntity;
          upsell['discount'] = discount_code;
          upsell['properties'] = properties;
          //console.log(upsell);
          items.push(upsell);
        });
            setTimeout(function () {
            //console.log(items);
            var content = addToCart(items);             
         }, 500); 

         console.log("Items===",items);
    });
    
    function addToCart(items)
     {
      jQuery.ajax({
        type: 'POST',
         url: "/cart/add.js",
        data: {items:items},
        dataType: 'json',
       success: function(data) {               
       // window.location.href = '/cart'; 
       console.log("Success==",data);
       
        // jQuery('.cart-drawer-container summary').trigger('click');
        jQuery('.bundle-drawer-right').removeClass('bundle-drawer-open');
        jQuery('body').removeClass('collection-bndle-open');
        jQuery('.custom-radios').removeClass('main-clicked');
        jQuery(".product-card__wrapper").removeClass("active")
        jQuery('.custom-radios').find('.choose-to-add-bundle').css("display", "block");
        jQuery('.custom-radios').find('.checked').css({ "display": "none" , "background": "#000"});
        jQuery('.cstm-append-cls').html('');
        jQuery('.product-variant-select option').eq(0).attr('selected','selected');
        eraseCookie('bundle-selected-product');

        //  updateCart();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        jQuery("cart-drawer").removeAttr("inert");
        jQuery("cart-drawer").removeAttr("hidden");
       setTimeout(() => {
    //      jQuery("#CartDrawer").load(window.location.href+" #CartDrawer")

     jQuery("cart-drawer").attr("open","")
       jQuery("cart-drawer").attr("active","")
       jQuery("header cart-count").removeAttr("hidden")
       jQuery("header cart-count").text(jQuery("#CartDrawer cart-count").text()); //Upgrade cart count in header icon
       }, 300);
        },
        error: function (xhr, ajaxOptions, thrownError) {
			console.log("error");
			console.log(xhr.status);
			console.log(thrownError);
		}
      });
    }
});















// /** cookies **/
// function getCookie(cname) {
//   let name = cname + "=";
//   let decodedCookie = decodeURIComponent(document.cookie);
//   let ca = decodedCookie.split(';');
//   for(let i = 0; i <ca.length; i++) {
//     let c = ca[i];
//     while (c.charAt(0) == ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) == 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return "";
// }
//    function setCookie(cname, cvalue, exdays) {
//   const d = new Date();
//   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//   let expires = "expires="+d.toUTCString();
//   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

// function eraseCookie(key) {
//         var keyValue = getCookie(key);
//         setCookie(key, keyValue, '-1');
//     }
// /** cookies end**/
// jQuery(document).ready(function(){ 

// /* NEW: detect if current template is new-custom-bundle-product */
// var isNewBundleTemplate = jQuery('[data-template-suffix="new-custom-bundle-product"]').length > 0;

// jQuery(document).on('click', '.product-card__swatches.custom-selector .swatches .swatch-value', function() {
  
//   let v_id = jQuery(this).data("v-id");
//   let style = jQuery(this).find("a.swatch-color").attr("style");
//   let option_value=jQuery(this).find(".option-badge-wrapper").html()
//  console.log("option_value===",option_value)
//   let targetColor = jQuery(this).closest(".product-card").find(".selected.swatch-value a.swatch-color");
//   let targetValue = jQuery(this).closest(".product-card").find(".selected.swatch-value .option-badge-wrapper");
//   targetColor.attr("style", style);
//     console.log("targetValue====",targetValue)
//   targetValue.html(option_value);
//   if (jQuery(this).find(".option-badge-wrapper").hasClass("has-badge")) {
//     targetValue.addClass("has-badge");
//   }
//   else{
// targetValue.removeClass("has-badge")
//   }

//   // console.log("Style==2==", targetColor.attr("style"));
//   console.log("v_id==", v_id);

//   jQuery(this).closest(".product-card").find("select.product-variant-select").val(v_id).trigger('change');
//     jQuery('.product-card__swatches.custom-selector .swatches').removeClass("active")
//      jQuery('.product-card__swatches.custom-selector').removeClass("active")
// });

//  jQuery(document).on('click', '.product-card__swatches.custom-selector .swatch-color-selected', function() {
//   // Remove 'active' class from all swatches
//   jQuery('.product-card__swatches.custom-selector .swatches').not(jQuery(this).siblings("ul.swatches")).removeClass('active');
//  jQuery('.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")).removeClass('active');
// //  console.log("test===", jQuery('.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")));
 
//   // Toggle 'active' only on the clicked element's sibling swatches
//   jQuery(this).siblings("ul.swatches").toggleClass("active");
//   jQuery(this).parents(".custom-selector").toggleClass("active");

//   console.log("show selector=5=", jQuery(this).siblings("ul"));
// });

// /* NEW: on new-custom-bundle-product, clicking CREATE YOUR BUNDLE auto-selects every product on the collection into the drawer */
// jQuery(document).on('click', '.bundle-drawer-btn .show-bundle-btn', function(e){
//   if(isNewBundleTemplate){
//     jQuery('.custom-radios').not('.main-clicked').each(function(){
//       jQuery(this).trigger('click');
//     });
//   }
// });


// var x=0;
//     var no_of_items = jQuery('.custom-radios').attr('numb-of-items');
// 	jQuery(document).on('click', '.custom-radios', function(e)	 { 
//  e.preventDefault();
//         console.log("Custom radio click====");
        
      
//     var data_id = jQuery(this).attr('data-attr');
//     var data_v_title = jQuery(this).attr('data-variant-title');
//     var data_v_price = jQuery(this).attr('data-price');
//     var data_v_img = jQuery(this).attr('data_img');
//     var data_p_title = jQuery(this).attr('data_product_title');
//     var data_p_id = jQuery(this).attr('data-pid');
//     var drawer_prdct = jQuery(this).parents(".f-column.card.bundle_template").find(".main-container-div-jtpl").html();
//     // console.log("drawer_prdct===");
    
//     jQuery(this).toggleClass("main-clicked");
//     jQuery(this).parents(".f-column").find(".product-card__wrapper").toggleClass("active");
//     var check_length =  jQuery(".custom-radios.main-clicked").length;
//   console.log("Items in cart==",jQuery('.cstm-append-cls .all-info-container').length );
  
//       if (jQuery(this).hasClass("main-clicked")){
//       jQuery(".cstm-append-cls").append(drawer_prdct);
//       console.log("product-appended===");
      
//       if(jQuery('.cstm-append-cls .all-info-container').length < 1){
//         console.log("Hide drawer button====");
        
//       jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//       }else{
//        jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
//        console.log("Show drawer button====");
//      }
//       if(isNewBundleTemplate){
//       jQuery('.bundle-drawer-btn').show();
//       }else{
//       if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
//       jQuery('.bundle-drawer-btn').show();
//       console.log("Show create bundle btn");
      
//       }else{
//       jQuery('.bundle-drawer-btn').hide();
//        console.log("Hide create bundle btn");
//       }
//       }
//       var productData=[];
//       var getBundledata= getCookie('bundle-selected-product');
//      if (getBundledata.length > 0){
//       getBundledata = getBundledata.split(',');
//       jQuery(getBundledata).each(function(index,value){
//       productData.push(value);
//      });
//    }if(productData.length >0){
//       if(productData.indexOf(data_id) < 0 ){
//       productData.push(data_id+'#'+data_v_title+'#'+data_v_price+'#'+data_p_title+'#'+data_v_img+'#'+data_p_id);
//      }
//    }
//     else{
//       productData.push(data_id+'#'+data_v_title+'#'+data_v_price+'#'+data_p_title+'#'+data_v_img+'#'+data_p_id);
//    }
//       setCookie('bundle-selected-product', productData, 1);
//       jQuery(this).parents('.bundle_template').find(".checked").css({ "display": "block" , "background": "#000"});
//       jQuery(this).parents('.bundle_template').find(".choose-to-add-bundle").css("display", "none"); 
//     }
//       else{
//         jQuery('.all-info-container.cart-product[var-id="'+data_id+'"]').find('.remove-prdct').trigger('click');
//         if(jQuery('.cstm-append-cls .all-info-container').length < 1){
//         jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//       }else{
//         jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
//      }
//           jQuery(this).parents('.bundle_template').find(".choose-to-add-bundle").css("display", "block"); 
//           jQuery(this).parents('.bundle_template').find(".checked").css({ "display": "none" , "background": "#000"});
//       }
// 	 return false;
//     });

   

//     jQuery(document).on('click', '.bundle-drawer-close-btn , .bundle-drawer-btn', function(){   
//       // alert('modalhere 1')
//      var drawer_prdct = jQuery(this).parents(".cc-product-block").find(".main-container-div-jtpl").html();
//      if(jQuery(this).hasClass('bundle-drawer-btn') && !isNewBundleTemplate){
//         jQuery(this).hide();
     
//      }
//       if(jQuery(this).hasClass('modal-close') && !isNewBundleTemplate){
//       if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
//         jQuery('.bundle-drawer-btn').show();

//         }else{
//         jQuery('.bundle-drawer-btn').hide();

//         }
//       }
//         jQuery('.bundle-drawer-right').toggleClass('bundle-drawer-open');
//         if(jQuery('.cstm-append-cls .all-info-container').length < 1){
//         jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//      }else{
//         jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
//      }
//       jQuery("body").toggleClass("collection-bndle-open");
//   });
  
//     jQuery(document).on('click', '.remove-prdct', function(){ 
//     var v_id = jQuery(this).parents(".all-info-container").attr('var-id');
//     var p_id = jQuery(this).parents(".all-info-container").attr('pd_id');        
//     jQuery(this).parents(".cstm-append-cls .all-info-container").remove();
       
//     jQuery('.custom-radios[data-attr="'+v_id+'"]').removeClass('main-clicked');
//     jQuery('.custom-radios[data-attr="'+v_id+'"]').parents(".f-column").find(".product-card__wrapper").removeClass("active")
//     jQuery('.custom-radios[data-attr="'+v_id+'"]').find('.choose-to-add-bundle').css("display", "block");
//     jQuery('.custom-radios[data-attr="'+v_id+'"]').find('.checked').css({ "display": "none" , "background": "#000"});
            
//     if(jQuery('.cstm-append-cls .all-info-container').length < 1){
//     jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//     }
//     if(!isNewBundleTemplate){
//     if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
//     jQuery('.bundle-bundle-btn.bundle_btn_active').show();
//     }else{
//     jQuery(".modal-close.bundle-drawer-close-btn").trigger('click');
//     }
//     }
   
//     var new_bndl_val=[];
//     var getBundledata= getCookie('bundle-selected-product');
//     getBundledata = getBundledata.split(',');
//     jQuery(getBundledata).each(function(index,value){
//     var variant_data = value.split('#');
//     if(variant_data[0] != v_id){
//     new_bndl_val.push(value);
//     }
//   });
//    setCookie('bundle-selected-product', new_bndl_val, 1);
//  });

//  jQuery(document).on('click', function(e){
//   var $drawer = jQuery('.bundle-drawer-right');

//   // drawer open hai aur click drawer ke bahar hua, aur trigger button pe bhi nahi hua
//   if($drawer.hasClass('bundle-drawer-open') &&
//      !jQuery(e.target).closest('.bundle-drawer-right').length &&
//      !jQuery(e.target).closest('.bundle-drawer-btn').length){

//     $drawer.removeClass('bundle-drawer-open');
//     jQuery("body").removeClass("collection-bndle-open");

//     // yehi logic jo close-btn click pe chalta hai, wahi yahan bhi chalana hoga
//     if(!isNewBundleTemplate){
//       if(jQuery('.cstm-append-cls .all-info-container').length >= no_of_items){
//         jQuery('.bundle-drawer-btn').show();
//       } else {
//         jQuery('.bundle-drawer-btn').hide();
//       }
//     }
//   }
// });



//  /* get bundle product cookies */
//     var productData=[];
//     var getBundledata= getCookie('bundle-selected-product');
//      if(jQuery('.cstm-append-cls .all-info-container').length <1){
//       jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//      }else{
//        jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
//      }
//    if(getBundledata != undefined && getBundledata.length >0){
//      getBundledata = getBundledata.split(',');
//      jQuery(getBundledata).each(function(index,value){
//    var variant_data = value.split('#');
//         console.log("variant_data==",variant_data);
//    var bundle_pd = jQuery(`<div class="all-info-container cart-product" var-id="${variant_data[0]}" pd_id=""><div class="product-media-jtpl cart-product__image"><img class="variantsel-img-bundle-jtpl" width='100' height='100' src="${variant_data[4]}"> </div><div class="product-details-info-jtpl cart-product__content"><p class="cart-product__content__title product-title">${variant_data[3]}</p><p class="cart-product__content__price"> <span class="prdct-price">${variant_data[2]}</span></p><span class="cart-product__content__meta prdct-variant">${variant_data[1]}</span></div><input class="variantsel-bundle-jtpl" name="id" value="${variant_data[0]}" type="hidden"><div class="cstm-remove-andqntty-jtpl">
//                    <div class="cstm-quantity-wrapper-jtpl">
//                    <a class="cstm-minus" id="ae-formFieldLabelOptIn_5k8gv4i1s47_14"><span>−</span></a>
//                 <input class="variantsel-bundle-jtpl-qntty"   min="1" name="quntity" value="1" type="number" aria-labelledby="ae-formFieldLabelOptIn_5k8gv4i1s47_14"/>
//                    <a class="cstm-plus"><span>+</span></a>
//                    </div>
//                    <span class="remove-prdct">Remove</span>
//                    </div>
//            </div>`);
//     jQuery('.inner.bundle-drawer.bundle-drawer-right span.cstm-append-cls').append(bundle_pd);
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('li.grid__item.bundle_template').find('.product-variant-select option[value="'+variant_data[0]+'"]').attr('selected','selected');
    
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').attr({'data-attr':variant_data[0],'data_img':variant_data[4],'data-price':variant_data[2],'data-variant-title':variant_data[1]});
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container').attr('var-id',variant_data[0]); 
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container img.variantsel-img-bundle-jtpl').attr('src',variant_data[4]); 
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container .product-details-info-jtpl .prdct-variant').html(variant_data[1]); 
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container .product-details-info-jtpl .variantsel-bundle-jtpl').attr('value',variant_data[0]);       
//     jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').addClass('main-clicked');
//     jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').parents(".f-column").find(".product-card__wrapper").addClass("active")
//     jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').find(".checked").css({ "display": "block" , "background": "#000"});
//     jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').find(".choose-to-add-bundle").css("display", "none"); 
//       });
 
 

//    }
//    setTimeout(function(){
//      jQuery('.product-variant-select').trigger("change");
//     if(isNewBundleTemplate){
//     jQuery('.bundle-drawer-btn').show();
//     }else{
//     if(jQuery('.inner.bundle-drawer.bundle-drawer-right .cstm-append-cls .all-info-container').length  >= no_of_items){
//     jQuery('.bundle-drawer-btn').show();
//     }else{
//     jQuery('.bundle-drawer-btn').hide();
//     }
//     }
//   });
//   jQuery('body').on('change', '.product-variant-select', function(e){
//     e.preventDefault();
//     var editid_bundle = jQuery(this).val();
//     var vr_img = jQuery(this).find('option:selected').attr('data-src-img');
//     var data_src = jQuery(this).find('option:selected').attr('data-src');
//     console.log("editid_bundle===",editid_bundle);
//     // console.log("vr_img===",vr_img);
//     // console.log("data_src===");
    
//     var vr_price = jQuery(this).find('option:selected').attr('data-vprice');
//     var vr_title = jQuery(this).find('option:selected').attr('variant-data');
//     console.log("vr_price===",vr_price);
//     // console.log("vr_title===",vr_title);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data_img',vr_img);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-price',vr_price);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-variant-title',vr_title);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .all-info-container').attr('var-id',editid_bundle);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .variantsel-img-bundle-jtpl').attr('src',vr_img);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .prdct-price').text(vr_price);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .prdct-variant').text(vr_title);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .variantsel-bundle-jtpl').val(editid_bundle);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.product-card__image img').attr('srcset',data_src);
     
//     var variant_id = jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-attr',editid_bundle);
//     var check_length = jQuery('.cstm-append-cls .all-info-container .variantsel-bundle-jtpl[value="'+editid_bundle+'"]').length;
//     if (check_length > 0){
//      jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').addClass('main-clicked');
//       jQuery(this).parents('.f-column.card.bundle_template').find(".product-card__wrapper").addClass("active");
//      jQuery(this).parents('.f-column.card.bundle_template').find(".checked").css({ "display": "block" , "background": "#000"});
//      jQuery(this).parents('.f-column.card.bundle_template').find(".choose-to-add-bundle").css("display", "none"); 
//     }else{
//       jQuery(this).parents('.f-column.card.bundle_template').find(".product-card__wrapper").removeClass("active");
//       jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').removeClass('main-clicked');
//      jQuery(this).parents('.f-column.card.bundle_template').find(".checked").css({ "display": "none" , "background": "#000"});
//      jQuery(this).parents('.f-column.card.bundle_template').find(".choose-to-add-bundle").css("display", "block"); 
//     }
//     return false;
//   });
//    /* Get bundle product cookies end*/
  
//     jQuery(document).on('click', '.cstm-minus', function(){
//     var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
//     prdct_quntity--;
//     jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").attr("value", prdct_quntity);
     
//     if(prdct_quntity < 1){
//     jQuery(this).parents(".all-info-container").find(".remove-prdct").trigger('click');
//     }
//     var qnty =0;
//     jQuery('.inner.cart-drawer .all-info-container .cstm-remove-andqntty-jtpl .variantsel-bundle-jtpl-qntty').each(function () {
//     qnty= qnty + parseInt(this.value);
//     });
//     if(qnty < 2){
//     jQuery(".cart-drawer-close-btn").trigger('click');
//     }
//    });
//     jQuery(document).on('click', '.cstm-plus', function(){
//     var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
//     var variant_id = jQuery(this).parents(".all-info-container").find('.variantsel-bundle-jtpl').attr('value');
//     prdct_quntity++;
//     jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").attr("value", prdct_quntity);
//  });

//      jQuery(document).on('click', '.custom-add-to-cart', function(){  
//       console.log("add to cart click===");
      
//          var items = new Array();
//          var discount_code = jQuery(".cartform .cart_bundle_disc").val();
//          jQuery('.cstm-append-cls .variantsel-bundle-jtpl').each(function() {
//           var upsell= {};
//           var pro_variant_id = jQuery(this).val();
//           var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
//           var properties = {};
//           properties["_bundle"] = "bundle";
//           if(jQuery("body").hasClass("page-pick-3-amp-save-50")){
//           properties["_pick_bundle"] = "pick-3-save-50";
//           }
//           upsell['id'] = pro_variant_id;
//           upsell['quantity'] = prdct_quntity;
//           upsell['discount'] = discount_code;
//           upsell['properties'] = properties;
//           //console.log(upsell);
//           items.push(upsell);
//         });
//             setTimeout(function () {
//             //console.log(items);
//             var content = addToCart(items);             
//          }, 500); 

//          console.log("Items===",items);
//     });
    
//     function addToCart(items)
//      {
//       jQuery.ajax({
//         type: 'POST',
//          url: "/cart/add.js",
//         data: {items:items},
//         dataType: 'json',
//        success: function(data) {               
//        // window.location.href = '/cart'; 
//        console.log("Success==",data);
       
//         // jQuery('.cart-drawer-container summary').trigger('click');
//         jQuery('.bundle-drawer-right').removeClass('bundle-drawer-open');
//         jQuery('body').removeClass('collection-bndle-open');
//         jQuery('.custom-radios').removeClass('main-clicked');
//         jQuery(".product-card__wrapper").removeClass("active")
//         jQuery('.custom-radios').find('.choose-to-add-bundle').css("display", "block");
//         jQuery('.custom-radios').find('.checked').css({ "display": "none" , "background": "#000"});
//         jQuery('.cstm-append-cls').html('');
//         jQuery('.product-variant-select option').eq(0).attr('selected','selected');
//         eraseCookie('bundle-selected-product');

//         //  updateCart();
//         document.dispatchEvent(new CustomEvent('cart:refresh'));
//         jQuery("cart-drawer").removeAttr("inert");
//         jQuery("cart-drawer").removeAttr("hidden");
//        setTimeout(() => {
//     //      jQuery("#CartDrawer").load(window.location.href+" #CartDrawer")

//      jQuery("cart-drawer").attr("open","")
//        jQuery("cart-drawer").attr("active","")
//        jQuery("header cart-count").removeAttr("hidden")
//        jQuery("header cart-count").text(jQuery("#CartDrawer cart-count").text()); //Upgrade cart count in header icon
//        }, 300);
//         },
//         error: function (xhr, ajaxOptions, thrownError) {
// 			console.log("error");
// 			console.log(xhr.status);
// 			console.log(thrownError);
// 		}
//       });
//     }
// });



// /** cookies **/
// function getCookie(cname) {
//   let name = cname + "=";
//   let decodedCookie = decodeURIComponent(document.cookie);
//   let ca = decodedCookie.split(';');
//   for(let i = 0; i <ca.length; i++) {
//     let c = ca[i];
//     while (c.charAt(0) == ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) == 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return "";
// }
//    function setCookie(cname, cvalue, exdays) {
//   const d = new Date();
//   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//   let expires = "expires="+d.toUTCString();
//   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

// function eraseCookie(key) {
//         var keyValue = getCookie(key);
//         setCookie(key, keyValue, '-1');
//     }
// /** cookies end**/
// jQuery(document).ready(function(){ 
// jQuery(document).on('click', '.product-card__swatches.custom-selector .swatches .swatch-value', function() {
  
//   let v_id = jQuery(this).data("v-id");
//   let style = jQuery(this).find("a.swatch-color").attr("style");
//   let option_value=jQuery(this).find(".option-badge-wrapper").html()
//  console.log("option_value===",option_value)
//   let targetColor = jQuery(this).closest(".product-card").find(".selected.swatch-value a.swatch-color");
//   let targetValue = jQuery(this).closest(".product-card").find(".selected.swatch-value .option-badge-wrapper");
//   targetColor.attr("style", style);
//     console.log("targetValue====",targetValue)
//   targetValue.html(option_value);
//   if (jQuery(this).find(".option-badge-wrapper").hasClass("has-badge")) {
//     targetValue.addClass("has-badge");
//   }
//   else{
// targetValue.removeClass("has-badge")
//   }

//   // console.log("Style==2==", targetColor.attr("style"));
//   console.log("v_id==", v_id);

//   jQuery(this).closest(".product-card").find("select.product-variant-select").val(v_id).trigger('change');
//     jQuery('.product-card__swatches.custom-selector .swatches').removeClass("active")
//      jQuery('.product-card__swatches.custom-selector').removeClass("active")
// });

//  jQuery(document).on('click', '.product-card__swatches.custom-selector .swatch-color-selected', function() {
//   // Remove 'active' class from all swatches
//   jQuery('.product-card__swatches.custom-selector .swatches').not(jQuery(this).siblings("ul.swatches")).removeClass('active');
//  jQuery('.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")).removeClass('active');
// //  console.log("test===", jQuery('.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")));
 
//   // Toggle 'active' only on the clicked element's sibling swatches
//   jQuery(this).siblings("ul.swatches").toggleClass("active");
//   jQuery(this).parents(".custom-selector").toggleClass("active");

//   console.log("show selector=5=", jQuery(this).siblings("ul"));
// });


// var x=0;
//     var no_of_items = jQuery('.custom-radios').attr('numb-of-items');
// 	jQuery(document).on('click', '.custom-radios', function(e)	 { 
//  e.preventDefault();
//         console.log("Custom radio click====");
        
      
//     var data_id = jQuery(this).attr('data-attr');
//     var data_v_title = jQuery(this).attr('data-variant-title');
//     var data_v_price = jQuery(this).attr('data-price');
//     var data_v_img = jQuery(this).attr('data_img');
//     var data_p_title = jQuery(this).attr('data_product_title');
//     var data_p_id = jQuery(this).attr('data-pid');
//     var drawer_prdct = jQuery(this).parents(".f-column.card.bundle_template").find(".main-container-div-jtpl").html();
//     // console.log("drawer_prdct===");
    
//     jQuery(this).toggleClass("main-clicked");
//     jQuery(this).parents(".f-column").find(".product-card__wrapper").toggleClass("active");
//     var check_length =  jQuery(".custom-radios.main-clicked").length;
//   console.log("Items in cart==",jQuery('.cstm-append-cls .all-info-container').length );
  
//       if (jQuery(this).hasClass("main-clicked")){
//       jQuery(".cstm-append-cls").append(drawer_prdct);
//       console.log("product-appended===");
      
//       if(jQuery('.cstm-append-cls .all-info-container').length < 1){
//         console.log("Hide drawer button====");
        
//       jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//       }else{
//        jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
//        console.log("Show drawer button====");
//      }
//       if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
//       jQuery('.bundle-drawer-btn').show();
//       console.log("Show create bundle btn");
      
//       }else{
//       jQuery('.bundle-drawer-btn').hide();
//        console.log("Hide create bundle btn");
//       }
//       var productData=[];
//       var getBundledata= getCookie('bundle-selected-product');
//      if (getBundledata.length > 0){
//       getBundledata = getBundledata.split(',');
//       jQuery(getBundledata).each(function(index,value){
//       productData.push(value);
//      });
//    }if(productData.length >0){
//       if(productData.indexOf(data_id) < 0 ){
//       productData.push(data_id+'#'+data_v_title+'#'+data_v_price+'#'+data_p_title+'#'+data_v_img+'#'+data_p_id);
//      }
//    }
//     else{
//       productData.push(data_id+'#'+data_v_title+'#'+data_v_price+'#'+data_p_title+'#'+data_v_img+'#'+data_p_id);
//    }
//       setCookie('bundle-selected-product', productData, 1);
//       jQuery(this).parents('.bundle_template').find(".checked").css({ "display": "block" , "background": "#000"});
//       jQuery(this).parents('.bundle_template').find(".choose-to-add-bundle").css("display", "none"); 
//     }
//       else{
//         jQuery('.all-info-container.cart-product[var-id="'+data_id+'"]').find('.remove-prdct').trigger('click');
//         if(jQuery('.cstm-append-cls .all-info-container').length < 1){
//         jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//       }else{
//         jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
//      }
//           jQuery(this).parents('.bundle_template').find(".choose-to-add-bundle").css("display", "block"); 
//           jQuery(this).parents('.bundle_template').find(".checked").css({ "display": "none" , "background": "#000"});
//       }
// 	 return false;
//     });

   

//     jQuery(document).on('click', '.bundle-drawer-close-btn , .bundle-drawer-btn', function(){   
//      var drawer_prdct = jQuery(this).parents(".cc-product-block").find(".main-container-div-jtpl").html();
//      if(jQuery(this).hasClass('bundle-drawer-btn')){
//         jQuery(this).hide();
     
//      }
//       if(jQuery(this).hasClass('modal-close')){
//       if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
//         jQuery('.bundle-drawer-btn').show();
//         }else{
//         jQuery('.bundle-drawer-btn').hide();
//         }
//       }
//         jQuery('.bundle-drawer-right').toggleClass('bundle-drawer-open');
//         if(jQuery('.cstm-append-cls .all-info-container').length < 1){
//         jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//      }else{
//         jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
//      }
//       jQuery("body").toggleClass("collection-bndle-open");
//   });
  
//     jQuery(document).on('click', '.remove-prdct', function(){ 
//     var v_id = jQuery(this).parents(".all-info-container").attr('var-id');
//     var p_id = jQuery(this).parents(".all-info-container").attr('pd_id');        
//     jQuery(this).parents(".cstm-append-cls .all-info-container").remove();
       
//     jQuery('.custom-radios[data-attr="'+v_id+'"]').removeClass('main-clicked');
//     jQuery('.custom-radios[data-attr="'+v_id+'"]').parents(".f-column").find(".product-card__wrapper").removeClass("active")
//     jQuery('.custom-radios[data-attr="'+v_id+'"]').find('.choose-to-add-bundle').css("display", "block");
//     jQuery('.custom-radios[data-attr="'+v_id+'"]').find('.checked').css({ "display": "none" , "background": "#000"});
            
//     if(jQuery('.cstm-append-cls .all-info-container').length < 1){
//     jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//     }
//     if(jQuery('.cstm-append-cls .all-info-container').length  >= no_of_items){
//     jQuery('.bundle-bundle-btn.bundle_btn_active').show();
//     }else{
//     jQuery(".modal-close.bundle-drawer-close-btn").trigger('click');
//     }
   
//     var new_bndl_val=[];
//     var getBundledata= getCookie('bundle-selected-product');
//     getBundledata = getBundledata.split(',');
//     jQuery(getBundledata).each(function(index,value){
//     var variant_data = value.split('#');
//     if(variant_data[0] != v_id){
//     new_bndl_val.push(value);
//     }
//   });
//    setCookie('bundle-selected-product', new_bndl_val, 1);
//  });

//  /* get bundle product cookies */
//     var productData=[];
//     var getBundledata= getCookie('bundle-selected-product');
//      if(jQuery('.cstm-append-cls .all-info-container').length <1){
//       jQuery('span.custom-add-to-cart.product-variant-submit-button').hide();
//      }else{
//        jQuery('span.custom-add-to-cart.product-variant-submit-button').show();
//      }
//    if(getBundledata != undefined && getBundledata.length >0){
//      getBundledata = getBundledata.split(',');
//      jQuery(getBundledata).each(function(index,value){
//    var variant_data = value.split('#');
//         console.log("variant_data==",variant_data);
//    var bundle_pd = jQuery(`<div class="all-info-container cart-product" var-id="${variant_data[0]}" pd_id=""><div class="product-media-jtpl cart-product__image"><img class="variantsel-img-bundle-jtpl" width='100' height='100' src="${variant_data[4]}"> </div><div class="product-details-info-jtpl cart-product__content"><p class="cart-product__content__title product-title">${variant_data[3]}</p><p class="cart-product__content__price"> <span class="prdct-price">${variant_data[2]}</span></p><span class="cart-product__content__meta prdct-variant">${variant_data[1]}</span></div><input class="variantsel-bundle-jtpl" name="id" value="${variant_data[0]}" type="hidden"><div class="cstm-remove-andqntty-jtpl">
//                    <div class="cstm-quantity-wrapper-jtpl">
//                    <a class="cstm-minus" id="ae-formFieldLabelOptIn_5k8gv4i1s47_14"><span>−</span></a>
//                 <input class="variantsel-bundle-jtpl-qntty"   min="1" name="quntity" value="1" type="number" aria-labelledby="ae-formFieldLabelOptIn_5k8gv4i1s47_14"/>
//                    <a class="cstm-plus"><span>+</span></a>
//                    </div>
//                    <span class="remove-prdct">Remove</span>
//                    </div>
//            </div>`);
//     jQuery('.inner.bundle-drawer.bundle-drawer-right span.cstm-append-cls').append(bundle_pd);
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('li.grid__item.bundle_template').find('.product-variant-select option[value="'+variant_data[0]+'"]').attr('selected','selected');
    
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').attr({'data-attr':variant_data[0],'data_img':variant_data[4],'data-price':variant_data[2],'data-variant-title':variant_data[1]});
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container').attr('var-id',variant_data[0]); 
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container img.variantsel-img-bundle-jtpl').attr('src',variant_data[4]); 
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container .product-details-info-jtpl .prdct-variant').html(variant_data[1]); 
//     jQuery('.custom-radios[data-pid="'+variant_data[5]+'"]').parents('.product-block__inner').find('.main-container-div-jtpl .all-info-container .product-details-info-jtpl .variantsel-bundle-jtpl').attr('value',variant_data[0]);       
//     jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').addClass('main-clicked');
//     jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').parents(".f-column").find(".product-card__wrapper").addClass("active")
//     jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').find(".checked").css({ "display": "block" , "background": "#000"});
//     jQuery('.custom-radios[data-attr="'+variant_data[0]+'"]').find(".choose-to-add-bundle").css("display", "none"); 
//       });
 
 

//    }
//    setTimeout(function(){
//      jQuery('.product-variant-select').trigger("change");
//     if(jQuery('.inner.bundle-drawer.bundle-drawer-right .cstm-append-cls .all-info-container').length  >= no_of_items){
//     jQuery('.bundle-drawer-btn').show();
//     }else{
//     jQuery('.bundle-drawer-btn').hide();
//     }
//   });
//   jQuery('body').on('change', '.product-variant-select', function(e){
//     e.preventDefault();
//     var editid_bundle = jQuery(this).val();
//     var vr_img = jQuery(this).find('option:selected').attr('data-src-img');
//     var data_src = jQuery(this).find('option:selected').attr('data-src');
//     console.log("editid_bundle===",editid_bundle);
//     // console.log("vr_img===",vr_img);
//     // console.log("data_src===");
    
//     var vr_price = jQuery(this).find('option:selected').attr('data-vprice');
//     var vr_title = jQuery(this).find('option:selected').attr('variant-data');
//     console.log("vr_price===",vr_price);
//     // console.log("vr_title===",vr_title);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data_img',vr_img);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-price',vr_price);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-variant-title',vr_title);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .all-info-container').attr('var-id',editid_bundle);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .variantsel-img-bundle-jtpl').attr('src',vr_img);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .prdct-price').text(vr_price);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .prdct-variant').text(vr_title);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.main-container-div-jtpl .variantsel-bundle-jtpl').val(editid_bundle);
//     jQuery(this).parents('.f-column.card.bundle_template').find('.product-card__image img').attr('srcset',data_src);
     
//     var variant_id = jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').attr('data-attr',editid_bundle);
//     var check_length = jQuery('.cstm-append-cls .all-info-container .variantsel-bundle-jtpl[value="'+editid_bundle+'"]').length;
//     if (check_length > 0){
//      jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').addClass('main-clicked');
//       jQuery(this).parents('.f-column.card.bundle_template').find(".product-card__wrapper").addClass("active");
//      jQuery(this).parents('.f-column.card.bundle_template').find(".checked").css({ "display": "block" , "background": "#000"});
//      jQuery(this).parents('.f-column.card.bundle_template').find(".choose-to-add-bundle").css("display", "none"); 
//     }else{
//       jQuery(this).parents('.f-column.card.bundle_template').find(".product-card__wrapper").removeClass("active");
//       jQuery(this).parents('.f-column.card.bundle_template').find('.custom-radios').removeClass('main-clicked');
//      jQuery(this).parents('.f-column.card.bundle_template').find(".checked").css({ "display": "none" , "background": "#000"});
//      jQuery(this).parents('.f-column.card.bundle_template').find(".choose-to-add-bundle").css("display", "block"); 
//     }
//     return false;
//   });
//    /* Get bundle product cookies end*/
  
//     jQuery(document).on('click', '.cstm-minus', function(){
//     var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
//     prdct_quntity--;
//     jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").attr("value", prdct_quntity);
     
//     if(prdct_quntity < 1){
//     jQuery(this).parents(".all-info-container").find(".remove-prdct").trigger('click');
//     }
//     var qnty =0;
//     jQuery('.inner.cart-drawer .all-info-container .cstm-remove-andqntty-jtpl .variantsel-bundle-jtpl-qntty').each(function () {
//     qnty= qnty + parseInt(this.value);
//     });
//     if(qnty < 2){
//     jQuery(".cart-drawer-close-btn").trigger('click');
//     }
//    });
//     jQuery(document).on('click', '.cstm-plus', function(){
//     var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
//     var variant_id = jQuery(this).parents(".all-info-container").find('.variantsel-bundle-jtpl').attr('value');
//     prdct_quntity++;
//     jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").attr("value", prdct_quntity);
//  });

//      jQuery(document).on('click', '.custom-add-to-cart', function(){  
//       console.log("add to cart click===");
      
//          var items = new Array();
//          var discount_code = jQuery(".cartform .cart_bundle_disc").val();
//          jQuery('.cstm-append-cls .variantsel-bundle-jtpl').each(function() {
//           var upsell= {};
//           var pro_variant_id = jQuery(this).val();
//           var prdct_quntity = jQuery(this).parents(".all-info-container").find(".variantsel-bundle-jtpl-qntty").val();
//           var properties = {};
//           properties["_bundle"] = "bundle";
//           if(jQuery("body").hasClass("page-pick-3-amp-save-50")){
//           properties["_pick_bundle"] = "pick-3-save-50";
//           }
//           upsell['id'] = pro_variant_id;
//           upsell['quantity'] = prdct_quntity;
//           upsell['discount'] = discount_code;
//           upsell['properties'] = properties;
//           //console.log(upsell);
//           items.push(upsell);
//         });
//             setTimeout(function () {
//             //console.log(items);
//             var content = addToCart(items);             
//          }, 500); 

//          console.log("Items===",items);
//     });
    
//     function addToCart(items)
//      {
//       jQuery.ajax({
//         type: 'POST',
//          url: "/cart/add.js",
//         data: {items:items},
//         dataType: 'json',
//        success: function(data) {               
//        // window.location.href = '/cart'; 
//        console.log("Success==",data);
       
//         // jQuery('.cart-drawer-container summary').trigger('click');
//         jQuery('.bundle-drawer-right').removeClass('bundle-drawer-open');
//         jQuery('body').removeClass('collection-bndle-open');
//         jQuery('.custom-radios').removeClass('main-clicked');
//         jQuery(".product-card__wrapper").removeClass("active")
//         jQuery('.custom-radios').find('.choose-to-add-bundle').css("display", "block");
//         jQuery('.custom-radios').find('.checked').css({ "display": "none" , "background": "#000"});
//         jQuery('.cstm-append-cls').html('');
//         jQuery('.product-variant-select option').eq(0).attr('selected','selected');
//         eraseCookie('bundle-selected-product');

//         //  updateCart();
//         document.dispatchEvent(new CustomEvent('cart:refresh'));
//         jQuery("cart-drawer").removeAttr("inert");
//         jQuery("cart-drawer").removeAttr("hidden");
//        setTimeout(() => {
//     //      jQuery("#CartDrawer").load(window.location.href+" #CartDrawer")

//      jQuery("cart-drawer").attr("open","")
//        jQuery("cart-drawer").attr("active","")
//        jQuery("header cart-count").removeAttr("hidden")
//        jQuery("header cart-count").text(jQuery("#CartDrawer cart-count").text()); //Upgrade cart count in header icon
//        }, 300);
//         },
//         error: function (xhr, ajaxOptions, thrownError) {
// 			console.log("error");
// 			console.log(xhr.status);
// 			console.log(thrownError);
// 		}
//       });
//     }
// });
